<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-5.basic100
          v-row(no-gutters)
            v-col
              p.mb-0.h6.basic800--text {{ $t('manage_shipping') }}

        v-card-text.pa-0
          v-form(ref="form")
            v-card.pa-5(flat)
              div.s1.primary--text {{ $t('shipping_method') }}
              p.s1.primary400--text {{ shippingMethod | shippingMethodDisplay}}
              div.s1.textColorMethod--text {{ $t('shipping_date') }}:
              v-date-picker.mt-4.mb-9(
                header-color="basic100"
                color="info400"
                v-model="shippingDate" :min="startDate"
                style="width:100%"
              )
              
              .zepto(v-if="shippingMethod == 'zepto'")
                div.s1.primary--text {{ $t('shipping_time') }}:
                div
                  //- v-time-picker.mt-4.mb-9(
                  //-   header-color="basic100"
                  //-   color="info400"
                  //-   v-model="shippingTime" :landscape="$vuetify.breakpoint.mdAndUp" full-width
                  //- )
                  v-text-field(
                      v-model="shippingTime"
                      hide-details dense outlined background-color="basic200" height="40"
                      readonly
                      @click="openPicker=!openPicker"
                      :append-icon="!openPicker ? 'mdi-chevron-down' : 'mdi-chevron-up'"
                  )
                  v-card.elevation-0(v-if="openPicker" style="border:1px solid var(--v-basic400)")
                    v-row.ma-0(width="100%" )
                      v-col.border-bottom
                        p.text-center.mb-0.s1.textColorHint--text Hr
                      v-col.border-bottom.border-x
                        p.text-center.mb-0.s1.textColorHint--text Min
                      v-col.border-bottom
                        p.text-center.mb-0.s1.textColorHint--text Am/Pm
                    v-row.ma-0(width="100%" )
                      v-col.pa-0
                        v-list.pa-0(max-height="300px" style="overflow-y:scroll;")
                          v-list-item.point-cursor(
                            :style="hour == h ? 'background-color: var(--v-info400);': ''" 
                            v-for="h in 12" :key="h" @click="hour=h; changeTime()"
                          )
                            v-list-item-content.text-center
                              p.mb-0.s1(:class="{ 'basic100--text': hour == h }") {{h | twoDigit}}
                      v-col.pa-0.border-x
                        v-list.pa-0(max-height="300px" style="overflow-y:scroll;")
                          v-list-item.point-cursor(
                            :style="min == m-1 ? 'background-color: var(--v-info400);': ''"
                            v-for="m in 60" :key="m-1" @click="min=m-1; changeTime()"
                          )
                            v-list-item-content.text-center
                              p.mb-0.s1(:class="{ 'basic100--text': min == m-1}") {{m-1 | twoDigit}}
                      v-col.pa-0
                        v-list.pa-0(max-height="300px" style="overflow-y:scroll;")
                          v-list-item.point-cursor(:style="ampm == 'AM' ? 'background-color: var(--v-info400);': ''" @click="ampm='AM'; changeTime()")
                            v-list-item-content.text-center
                              p.mb-0.s1(:class="{ 'basic100--text': ampm == 'AM' }") AM
                          v-list-item.point-cursor(:style="ampm == 'PM' ? 'background-color: var(--v-info400);': ''" @click="ampm='PM'; changeTime()")
                            v-list-item-content.text-center
                              p.mb-0.s1(:class="{ 'basic100--text': ampm == 'PM' }") PM

        //- v-divider
        v-card-actions
          v-spacer
          v-btn(text @click='showModal = false')
            .button-Aa-small.primary400--text| {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 :loading="isLoading" @click='clickSave' :disabled="shippingMethod == 'zepto' && !shippingTime")
            .button-AA-small.basic100--text| {{ $t('ship_parcel') }}

    .modals
      y-dialog(v-model="openBillWindowDialog" width="400px" persistent)
        v-card
          v-card-title {{ $t('dialog_please_pay') }}
          v-card-text.px-6
            div {{ $t('dialog_please_pay_text') }}
          v-card-actions
            v-spacer
            v-btn(text @click="$router.push('/admin/settings/zeptoexpress')")
              .button-Aa-small.primary400--text| {{ $t('view_job_list') }}
            v-btn.mr-2(color='textColorAccent' depressed height=32 @click='openPaymentPage()')
              .button-AA-small.basic100--text| {{ $t('pay_now') }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ShipItemDialog',
  props: ['open', 'parentLead'],
  data: (v) => ({
    hour:'0',
    min:'0',
    ampm:'AM',
    openPicker: false,
    billUrl: '',
    openBillWindowDialog: false,
    shippingDate: v.parentLead.shipping.pickup_date || new Date().toISOString().substr(0, 10),
    startDate: new Date().toISOString().substr(0, 10),
    shippingTime: v.parentLead.shipping.pickup_time,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  mounted(){
    this.hour = this.shippingTime.slice(0, 2)
    if (this.hour < 12) {
      this.ampm = 'AM'
    }else{
      this.ampm = 'PM'
    }
    this.hour = (this.hour % 12) || 12;
    this.min = this.shippingTime.slice(3, 5)
  },
  filters: {
    twoDigit(value) {
      if(value<10){
        value='0'+value
      }
      return value
    },
    fullTimeFormat(value){
      var hour = value.slice(0, 2)
      var min = value.slice(3, 5)
      var ampm = ''
      if (hour < 12) {
        ampm = 'AM'
      }else{
        ampm = 'PM'
      }
      hour = (this.hour % 12) || 12;
      return this.$options.filters.twoDigit(hour)+':'+this.$options.filters.twoDigit(min)+' '+ampm
    }
  },
  computed: {
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('update:parentLead', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    shippingMethod () {
      if (this.lead.shipping && this.lead.shipping.shipping_method) {
        return this.lead.shipping.shipping_method
      }
      return 'manual'
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    openPaymentPage () {
      window.open(this.billUrl, '_blank')
    },
    changeTime(){
      var hrs = this.hour
      var mins = this.min
      if (this.ampm=='PM') {
        if (hrs < 12) {
          hrs = hrs + 12
        }
        return this.shippingTime = this.$options.filters.twoDigit(hrs)+':'+this.$options.filters.twoDigit(mins)+':00'
      }else if (this.ampm=='AM') {
        if (hrs == 12) {
          hrs = hrs - 12
        }
        return this.shippingTime = this.$options.filters.twoDigit(hrs)+':'+this.$options.filters.twoDigit(mins)+':00'
      }
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      let params = {}
      this.isLoading = true
      if (this.shippingMethod == 'easyparcel') {
        params = {
          pickup_date: this.shippingDate
        }
      } else if (this.shippingMethod == 'zepto') {
        params = {
          pickup_date: this.shippingDate,
          pickup_time: this.shippingTime
        }
      } else {
        this.showMessage(['error', this.$t('error_message.this_method_not_supported')])
        return
      }
      this.axios.patch(`/shipping/shippings/${this.lead.shipping.id}/`, params)
      .then(() => {
        this.axios.get(`/leads/${this.lead.pid}/`, this.customer)
        .then(resp => {
          this.lead = resp.data
          this.$set(this.lead, 'shipping', resp.data.shipping)
        })
        if (['easyparcel', 'zepto'].includes(this.shippingMethod)){
          this.submitShipping()
        }
      })
      .catch(() => {
        this.isLoading = false
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
    },
    submitShipping(){
      // Let back end handles shipping
      this.axios.post(`/leads/${this.lead.pid}/submit_shipping`)
        .then(resp => {
          if (this.lead.shipping.shipping_method == 'zepto') {
            this.billUrl = resp.data.bill_url
            if (this.billUrl) {
              this.openBillWindowDialog = true
            } else {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
              this.isProcessing = false
            }
            return
          }
          this.showMessage(['success', `Request sent to ${this.lead.shipping.shipping_method}`])
          // this.lead.shipping.status = 'pending'
          this.$set(this.lead.shipping, 'status', 'pending')
          this.showModal = false
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.message) {
            this.showMessage(['error', e.response.data.message])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.border-bottom{
    border-bottom: 1px solid var(--v-basic400);
    border-radius: 0 !important;
}
.border-x{
  border-left: 1px solid var(--v-basic400);
  border-right: 1px solid var(--v-basic400);
}
.currentTime{
  background-color: var(--v-info400);
  color: white !important;
}
.point-cursor{
  cursor: pointer;
}
div >>> .v-date-picker-title__year{
    display: none;
}
div >>> .v-date-picker-title__date {
    display: none;
}
div >>> .v-picker__title {
    color: var(--v-primary500);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 0;
}
div >>> .v-picker__body{
  width: 100% !important;
}
div >>> .v-picker__title__btn{
  /* border-top: 1px solid var(--v-basic300); */
  border-bottom: 1px solid var(--v-basic300);
  padding: 8px 0;
  margin:0;
}
div >>> .v-date-picker-header{
  border-top: 1px solid var(--v-basic300);
  border-bottom: 1px solid var(--v-basic300);
}
div >>> .v-time-picker-title__time{
  color: black
}
div >>> .v-time-picker-title__ampm{
  color: black;
  margin-bottom:0;
}
div >>> .v-time-picker-title{
    border-bottom: 1px solid var(--v-basic300);
    border-top: 1px solid var(--v-basic300);
}
div >>> .v-date-picker-table th {
    font-size: 15px;
    color:var(--v-textColorHint) !important;
}
div >>> .v-date-picker-table--date .v-btn {
    height: 32px;
    width: 32px;
    font-size: 15px !important;
    font-weight: 600;
    border-radius: 4px !important;
}
div >>> .v-date-picker-table__current{
  border: 1px solid var(--v-primary);
  /* color: var(--v-primary); */
  background-color: var(--v-primaryT08);
}
div >>> .theme--light.v-btn.v-btn--disabled {
    color:var(--v-textColorHint) !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
div >>> .v-date-picker-table--month td .v-btn {
    margin: 0 auto;
    max-width: 140px;
    min-width: 40px;
    width: 100%;
    font-size: 15px !important;
    font-weight: 600 !important;
}
div >>> .v-date-picker-years {
    font-size: 15px;
    font-weight: 600;
    height: 290px;
    list-style-type: none;
    overflow: auto;
    text-align: center;
}
</style>

<i18n>
{
  "en": {
    "manage_shipping": "Manage Shipping",
    "ship_parcel": "Ship parcel"
  },
  "id": {
    "manage_shipping": "Kelola pengiriman",
    "ship_parcel": "Kirim paket"
  }
}
</i18n>
